import {CreateInstance} from './config'
const favorateAPI = CreateInstance('favorate')
export default favorateAPI
